import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App';
import SessionRecordingManager from './components/SessionRecordingManager';
import { ensureGeoResolved } from './utils/geo';
import { initPostHog } from './utils/posthog';
import * as serviceWorker from './serviceWorker';

// STY-445: PostHog (capture-mode model, consent-free — no cookie banner). Resolve geo first so the
// capture mode / persistence are correct (sets the geo_eu cookie via /api-nextjs/geo when absent),
// then init. Host-gated to prod inside initPostHog, so this no-ops in dev / on non-prod hosts.
ensureGeoResolved().then(initPostHog);

ReactDOM.render((
  <BrowserRouter>
    <SessionRecordingManager />
    <App />
  </BrowserRouter>
), document.getElementById('root'));

serviceWorker.unregister()